import React from 'react';
import './AddItem.css';
import { useForm } from "react-hook-form";

const AddItem = () => {
    const { register, handleSubmit } = useForm();
    const onSubmit = data =>{
        console.log(data)

    }

    return (
        <div className="add-item">
            <h2>add item</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <input {...register("name", { required: true, maxLength: 20 })} placeholder="Name" />
                <input {...register("email")} placeholder="Email" />
                <textarea {...register("Address")} placeholder="Address" />
                <input {...register("City")} placeholder="City"/>
                <input {...register("Phone")} placeholder="Phone"/>
                <input type="submit" />
            </form>
        </div>
    );
};

export default AddItem;